import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button, Card, Container, Form } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import { ActionButtons, Loader, SectionHeader } from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { LOADING_STATUS } from '../../common/constants';
import {
  CustomerGroupDetailsTranslations,
  CustomerGroupUpdateData,
  getCustomerGroupDetailsAsync,
  selectCustomerGroupDetails,
  selectCustomerGroupDetailsLoadingStatus,
  CustomerGroupTranslationsdata,
  updateCustomerGroup,
} from '../Users/identityUsersSlice';

function CustomerGroupDetails() {
  const backLinkUrl = '/customers/customergroups';
  const params = useParams();
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useAppDispatch();
  const customerGroupDetails = useAppSelector(selectCustomerGroupDetails);
  const [customerGroupTemp, setCustomerGroup] = useState(customerGroupDetails);
  const customerGroupDetailsLoadingStatus = useAppSelector(
    selectCustomerGroupDetailsLoadingStatus,
  );
  function getItem(locale, keyId, item) {
    if (customerGroupDetailsLoadingStatus === LOADING_STATUS.IDLE) {
      const found = item.translations.filter(
        a => a.locale === locale && a.keyId === keyId,
      );
      if (found && found[0] && found[0].text) {
        return found[0].text;
      }
    }
    return '';
  }

  const handleInputChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setCustomerGroup({ ...customerGroupTemp, [name]: value });
    setSubmitted(false);
  };

  const editTranslations = (translations, keyId, locale, value) => {
    let exist = false;

    translations = translations.map(item => {
      const temp = { ...item, item };
      if (temp.keyId === keyId && temp.locale === locale) {
        temp.text = value;
        exist = true;
      }
      return temp;
    });
    if (!exist) {
      const newitem: CustomerGroupDetailsTranslations = {
        locale,
        keyId,
        text: value,
        customerGroupId: customerGroupTemp.id,
        id: 'new',
      };
      translations = [...translations, newitem];
      return translations;
    }
    return translations;
  };

  const handleInputChangeTranslation = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { id } = target;
    const { name } = target;
    let translationsTemp = customerGroupTemp.translations;
    if (id.endsWith('FiFi')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'fi_FI',
        value,
      );
    } else if (id.endsWith('EnEn')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'en_EN',
        value,
      );
    } else if (id.endsWith('RuRu')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'ru_RU',
        value,
      );
    }

    const storeCustomerGroup = { ...customerGroupTemp };
    storeCustomerGroup.translations = translationsTemp;
    setCustomerGroup(storeCustomerGroup);
    setSubmitted(false);
  };

  const tableStyle = {
    border: '1px solid #D2DDEC',
    width: '100%',
  };

  function dbDatetoCalendar(date) {
    // this is rude temp solution until we have proper
    // date dandling and calendar options
    const tempDateObj = new Date(date);
    let retval = tempDateObj.getFullYear().toString();
    retval += '-';
    let temMonth = '0';
    temMonth += tempDateObj.getMonth() + 1;
    temMonth = temMonth.slice(-2);
    retval += temMonth;
    retval += '-';
    let tempDate = '0';
    tempDate += tempDateObj.getDate();
    tempDate = tempDate.slice(-2);
    retval += tempDate;

    return retval;
  }
  const saveCustomerGroup = () => {
    const translations = customerGroupTemp.translations.map(item => {
      return {
        keyId: item.keyId,
        locale: item.locale,
        text: item.text,
        id: item.id,
        customerGroupid: item.customerGroupId,
      } as unknown as CustomerGroupTranslationsdata;
    });
    const customerGroupUpdateData = {
      id: customerGroupTemp.id,
      defaultCustomerGroup: customerGroupTemp.defaultCustomerGroup,
      regularCustomerGroup: customerGroupTemp.regularCustomerGroup,
      travelAgencyCustomerGroup: customerGroupTemp.travelAgencyCustomerGroup,
      wintimeCustomerGroupId: customerGroupTemp.wintimeCustomerGroupId,
      wintimeCustomerGroupNumber: customerGroupTemp.wintimeCustomerGroupNumber,
      automaticWelcomesDisabled: customerGroupTemp.automaticWelcomesDisabled,
      translations,
    } as CustomerGroupUpdateData;
    dispatch(updateCustomerGroup(customerGroupUpdateData));
  };

  const initFetch = useCallback(() => {
    dispatch(getCustomerGroupDetailsAsync(params.customergroupId));
  }, [dispatch, params.Id]);

  useEffect(() => {
    initFetch();
    setCustomerGroup(customerGroupDetails);
  }, [initFetch, customerGroupDetails.id]);

  return (
    <>
      <Helmet>
        <title>Asiakasryhmä - tiedot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Asiakkaat ja ryhmät', 'Asiakasryhmät']}
          Title={getItem('fi_FI', 'CustomerGroupName', customerGroupTemp)}
        />

        {customerGroupDetailsLoadingStatus === LOADING_STATUS.LOADING && (
          <Loader IsLoading />
        )}

        {customerGroupDetailsLoadingStatus === LOADING_STATUS.IDLE && (
          <Container className="container-form mt-48">
            <Form.Group controlId="CustomerGroupNameFiFi" className="mb-40">
              <Form.Label className="required">Ryhmän Nimi FI</Form.Label>
              <Form.Control
                autoComplete="off"
                required
                value={getItem('fi_FI', 'CustomerGroupName', customerGroupTemp)}
                onChange={handleInputChangeTranslation}
                name="CustomerGroupName"
              />
            </Form.Group>

            <Form.Group controlId="CustomerGroupNameEnEn" className="mb-40">
              <Form.Label className="required">Ryhmän Nimi EN</Form.Label>
              <Form.Control
                autoComplete="off"
                required
                value={getItem('en_EN', 'CustomerGroupName', customerGroupTemp)}
                onChange={handleInputChangeTranslation}
                name="CustomerGroupName"
              />
            </Form.Group>

            {/* <Form.Group controlId="CustomerGroupNameRuRu" className="mb-40"> */}
            {/*  <Form.Label className="required">Ryhmän Nimi RU</Form.Label> */}
            {/*  <Form.Control */}
            {/*    autoComplete="off" */}
            {/*    required */}
            {/*    value={getItem('ru_RU', 'CustomerGroupName', customerGroupTemp)} */}
            {/*    onChange={handleInputChangeTranslation} */}
            {/*    name="CustomerGroupName" */}
            {/*  /> */}
            {/* </Form.Group> */}

            <hr className="hr-light mb-40" />

            <Form.Group className="mb-24">
              <Form.Check
                checked={customerGroupTemp.travelAgencyCustomerGroup}
                className="mb-24"
                id="travelAgencyCustomerGroup"
                inline
                label="Matkatoimisto ryhmä"
                name="travelAgencyCustomerGroup"
                onChange={handleInputChange}
              />
              <Form.Check
                checked={customerGroupTemp.regularCustomerGroup}
                className="mb-24"
                id="regularCustomerGroup"
                inline
                label="Kanta-asiakas ryhmä"
                name="regularCustomerGroup"
                onChange={handleInputChange}
              />
              <Form.Check
                checked={customerGroupTemp.defaultCustomerGroup}
                className="mb-24"
                id="defaultCustomerGroup"
                inline
                label="Oletusasiakasryhmä"
                name="defaultCustomerGroup"
                onChange={handleInputChange}
              />
              <Form.Check
                checked={customerGroupTemp.automaticWelcomesDisabled}
                className="mb-24"
                id="automaticWelcomesDisabled"
                inline
                label="Ei tervetuloaviestejä"
                name="automaticWelcomesDisabled"
                onChange={handleInputChange}
              />
            </Form.Group>

            <hr className="hr-light mb-40" />

            <Form.Group
              controlId="wintimeCustomerGroupNumber"
              className="mb-40"
            >
              <Form.Label className="required">Wintime asiakasryhmä</Form.Label>
              <Form.Control
                type="number"
                required
                value={customerGroupTemp.wintimeCustomerGroupNumber || ''}
                onChange={handleInputChange}
                name="wintimeCustomerGroupNumber"
              />
            </Form.Group>

            <Form.Group controlId="wintimeCustomerGroupId" className="mb-40">
              <Form.Label className="required">Wintime asiakasryhmä</Form.Label>
              <Form.Control
                required
                value={customerGroupTemp.wintimeCustomerGroupId || ''}
                onChange={handleInputChange}
                name="wintimeCustomerGroupId"
              />
            </Form.Group>

            <ActionButtons
              CancelButtonUrl={backLinkUrl}
              HideSaveButton={false}
              HandleSave={saveCustomerGroup}
              SaveButtonText="Tallenna"
            />
          </Container>
        )}
      </Container>
    </>
  );
}

export default CustomerGroupDetails;
